import { ChatFileMessage } from "context/adminContext";
import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
// import { API_ORIGIN } from "helpers/constants";
import { ChatFilesMessage } from "Components/ChatFiles/ChatFilesMessage";
import styles from "./index.module.css";
import { formatMessageDateTime } from "helpers/format";
import { getAvatarSrc } from "Components/UserNameRatingPhotoComponent/UserNameRatingPhotoComponent";

type Props = {
  messageId: number;
  avatar?: string;
  messageCreatedAt: string;
  isFiles: boolean;
  content: ChatFileMessage[];
};

export const UserMessage = ({ content, isFiles, messageCreatedAt, messageId, avatar }: Props) => {
  const isZ = messageCreatedAt.at(-1) === "Z";
  const bubble = (
    <div className={styles.otherMessages} id={`message-${messageId}`}>
      <div className={styles.avatarOfUser}>
        {avatar ? (
          <Avatar src={getAvatarSrc(avatar)} size={46} shape="circle" />
        ) : (
          // <Avatar src={`${API_ORIGIN}/public/avatars/${avatar}`} size={46} shape="circle" />
          <Avatar icon={<UserOutlined />} size={46} shape="circle" />
        )}
      </div>
      <div>
        <div className={styles.messageDate}>{formatMessageDateTime(`${messageCreatedAt}${isZ ? "" : "Z"}`)}</div>
        {!isFiles ? <div className={styles.message}>{content[0].content}</div> : null}
      </div>
    </div>
  );

  if (!isFiles) return bubble;

  // Время — отдельным пузырём, файлы под ним
  return (
    <div className={styles.filesGroup + " " + styles.otherFilesGroup}>
      {bubble}
      <ChatFilesMessage files={content} />
    </div>
  );
};
